import config from "@config";
import useContract from "@hooks/useContract";
import useNodesCount from "@hooks/useNodesCount";
import type { Address } from "viem";

const useNodeContractVersionAbi = (account: string) => {
	const {
		nodeController04Abi,
		nodeController04Contract,
		nodeController05Abi,
		nodeController05Contract,
	} = useContract();
	const nodesCountOld = useNodesCount(
		account,
		nodeController04Contract?.address as Address,
		nodeController04Abi,
	);
	const nodesCountNew = useNodesCount(
		account,
		nodeController05Contract?.address as Address,
		nodeController05Abi,
	);

	// @notice: only until NFTs are soulbound
	if (nodesCountOld > nodesCountNew) {
		return {
			contractAbi: nodeController04Abi,
			contractAddress: config.web3.nodeController04Address,
			nodesCountNew,
			nodesCountOld,
		};
	}

	return {
		contractAbi: nodeController05Abi,
		contractAddress: config.web3.nodeController05Address,
		nodesCountNew,
		nodesCountOld,
	};
};

export default useNodeContractVersionAbi;
